import React, { Component, Fragment } from "react";
import { Route, withRouter } from "react-router-dom";
import PageTransition from "react-router-page-transition";
import { func, shape, node, bool, string, oneOfType } from "prop-types";
// import { getTransition } from "util/transition";

import ErrorBoundary from "pages/_components/ErrorBoundary";
import { resizableRoute } from "pages/_components/Resizable";
import { Grid } from "react-bootstrap";
import classNames from "classnames";

class ExternalLayout extends Component {
    static propTypes = {
        className: string,
        dispatch: func,
        history: shape({}).isRequired,
        fetching: bool,
        location: shape({}).isRequired,
        transition: string,
        component: oneOfType([func, node]).isRequired,
        isDesktop: bool,
        isMobile: bool,
        isMobileNative: bool,
    };

    static defaultProps = {
        className: "",
        isDesktop: false,
        isMobile: false,
        isMobileNative: false,
        transition: "",
        dispatch: null,
        fetching: false,
    };

    getMobileLayout = (matchProps) => {
        const { component: ReceivedComponent, isMobile, isDesktop, isMobileNative, location, className } = this.props;
        const extras = { isMobile, isDesktop, isMobileNative };

        const islogin = location === "/loginStep4" || location === "/onboarding/stepStartOnMobile";

        return (
            <div className={classNames(className, { "login-background": !islogin })}>
                <PageTransition timeout={0}>
                    <div className="transition-item">
                        <div className="view-wrapper scrollable-content">
                            <ErrorBoundary>
                                <ReceivedComponent {...matchProps} {...extras} />
                            </ErrorBoundary>
                        </div>
                    </div>
                </PageTransition>
            </div>
        );
    };

    getDesktopLayout = (matchProps) => {
        const {
            component: ReceivedComponent,
            isMobile,
            isDesktop,
            isMobileNative,
            // // location: { pathname },
            transition,
            className,
        } = this.props;
        const extras = { isMobile, isDesktop, isMobileNative };
        const twoColLayout = className === "fifty-fifty-layout";

        return (
            <div className={`${transition} ${className} login-background`}>
                <PageTransition
                    timeout={transition ? 600 : 0}
                    style={{
                        background: "linear-gradient(transparent, transparent 67.5%, black)",
                    }}>
                    <div className="app transition-item">
                        {className === "fifty-fifty-layout" && (
                            <div className="column-left">
                                <h1 className="inverse">
                                    Bienvenido a la <span className="highlighted">próxima experiencia</span> bancaria.
                                </h1>
                            </div>
                        )}

                        <ErrorBoundary>
                            <section className={`container--layout items-center ${twoColLayout && "column-right"}`}>
                                <Grid className="panel">
                                    <main className="app-default-content" role="main">
                                        <ReceivedComponent {...matchProps} {...extras} />
                                    </main>
                                </Grid>
                            </section>
                        </ErrorBoundary>
                    </div>
                </PageTransition>
            </div>
        );
    };

    render() {
        const { component: ReceivedComponent, ...rest } = this.props;

        return (
            <Route
                {...rest}
                render={(matchProps) => {
                    const { isMobile } = this.props;

                    if (isMobile) {
                        return <Fragment>{this.getMobileLayout(matchProps)}</Fragment>;
                    }

                    return <Fragment>{this.getDesktopLayout(matchProps)}</Fragment>;
                }}
            />
        );
    }
}

export default withRouter(resizableRoute(ExternalLayout));
